import { SubpageLayout2018 } from './subpageLayout';

export default function Sponsors2018() {
  return (
    <SubpageLayout2018 lang="en" title="Sponsors" page="sponsors">
      <div className="sponsors_para_introduction para_introduction">
        <h1>Sponsors</h1>
        <div className="center_introduction">
          <p className="p1">
            Hong Kong Smart City Summit cum Smart City Awards 2018 provide our sponsors with unique brand building opportunities among a wide network of leading businesses and individuals from across the innovation and technology sector.
            <br />
            <br />
            As a sponsor, your company will be associated with excellence and innovation, boosting its profile within the industry and positioning your brand as a thought leader in the space.
            <br />
            <br />
            The sponsor will present the trophy to winners. It is a great honour for the winners to receive the award from the prestigious industry leader.
            <br />
            <br />
            To be our sponsor of Hong Kong Smart City Summit cum Smart City Awards 2018, our extensive marketing and public relations campaign assists us to generate interest in the Awards whilst promoting our sponsors as the supportive industry players.
          </p>
        </div>
        <div className="public_exposure_container">
          <div className="public_container">
            <div className="public_leading">
              <p className="p1">The public and industry support of the Awards will provide various positive opportunities for sponsors to be aligned with a wide range of commercial activities:</p>
            </div>
            <div className="public_text">
              <p>• Press <br />• Printed Material <br />• Online and Social Media <br />• Advertisements on outdoor and etc.</p>
            </div>
          </div>
          <div className="exposure_container">
            <div className="exposure_leading">
              <p className="p1">Sponsors will find significant opportunities for exposure within:</p>
            </div>
            <div className="exposure_text">
              <p>• Leading corporations and businesses <br />• Industry players and associations <br />• General public, through significant mass media exposure</p>
            </div>
          </div>
        </div>
        <div className="organiser sponsor">
          <div className="sponsor" style={{justifyContent: 'start'}}>
            <a href="https://www.clp.com.hk/en" target="_blank" rel="noreferrer"><img src="/2018/images/logo/clp.png" alt="" /></a>
            <a href="https://www2.deloitte.com/cn/en.html" target="_blank" rel="noreferrer"><img src="/2018/images/logo/deloitte.png" alt="" /></a>
            <a href="http://www.ey.com/home" target="_blank" rel="noreferrer"><img src="/2018/images/logo/ey.png" alt="" /></a>
            <a href="https://home.kpmg.com/cn/en/home.html" target="_blank" rel="noreferrer"><img src="/2018/images/logo/kpmg.png" alt="" /></a>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

